import { render } from "./Nofound.vue?vue&type=template&id=76c118a2"
import script from "./Nofound.vue?vue&type=script&lang=js"
export * from "./Nofound.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__